import { HomeGroupRank } from "src/data/homeGroups/types/homeGroupTypes"
import { THomeGroupRole } from "src/data/homeGroups/types/homeGroupTypes"

/** Get the access rank of a role */
export function getHomeGroupAccessRank(
  role: THomeGroupRole | undefined
): HomeGroupRank {
  switch (role) {
    case "admin":
      return HomeGroupRank.ADMIN
    default:
      return HomeGroupRank.MEMBER
  }
}

export function hasHomeGroupAccess(
  role: THomeGroupRole | undefined,
  minLevel: THomeGroupRole = "member"
): boolean {
  if (role === undefined) {
    return false
  }
  const rank = getHomeGroupAccessRank(role)
  const minRank = getHomeGroupAccessRank(minLevel)
  return rank >= minRank
}
